import { render, staticRenderFns } from "./GameModal.vue?vue&type=template&id=29a92595&scoped=true"
import script from "./GameModal.vue?vue&type=script&lang=ts"
export * from "./GameModal.vue?vue&type=script&lang=ts"
import style0 from "./GameModal.vue?vue&type=style&index=0&id=29a92595&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a92595",
  null
  
)

export default component.exports